<template>
  <component :is="way" />
</template>
<script>
  import AdditionalResponseDefault from "./default.vue";
  import PROCESS_NAMES from "@/process/names";

  const AdditionalResponseSiburStajirovki = () =>
    import(/* webpackChunkName: "sibur-stajirovki" */ "@/process/sibur-stajirovki/components/response/additional-response/index.vue");


  export default {
    name: "additional-response",
    components: {
      AdditionalResponseDefault,
      AdditionalResponseSiburStajirovki,
    },
    computed: {
      way() {
        let way = "additional-response";
        const process = this.$store.getters["response/process"];
        console.log('process', process);
        if (
          process === PROCESS_NAMES.SIBUR_INTERNSHIPS
        ) {
          return `${way}-${process}`;
        } else {
          return `${way}-default`;
        }
      }
    }
  };
</script>
